import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { TermsModalContainer } from '@/features/iam/terms/TermsModal/TermsModalContainer'
import { ProSoftwareReviewModalContainer } from '@/features/iam/providers/ProSoftwareReviewModal/ProSoftwareReviewModalContainer'

export default observer(function Inner() {
  const { iam } = useFeatures((r) => ({ iam: r.iam }))

  return (
    <>
      <TermsModalContainer vm={iam.termsModalViewModel} />
      <ProSoftwareReviewModalContainer
        vm={iam.proSoftwareReviewModalViewModel}
      />
    </>
  )
})
